const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

/** Imaginile servite prin API (cookie auth) sunt stocate ca "/api/..." — prefixăm cu backend-ul. */
export function mediaUrl(src) {
  if (!src) return null;
  return src.startsWith("/api/") ? `${BACKEND_URL}${src}` : src;
}

export const PLACEHOLDER_COVER =
  "data:image/svg+xml;utf8," +
  encodeURIComponent(
    `<svg xmlns='http://www.w3.org/2000/svg' width='1600' height='900'><defs><linearGradient id='g' x1='0' y1='0' x2='1' y2='1'><stop offset='0' stop-color='#1c1c1e'/><stop offset='1' stop-color='#3a3a3f'/></linearGradient></defs><rect width='1600' height='900' fill='url(#g)'/><text x='50%' y='52%' fill='#8a8a90' font-family='Arial' font-size='44' text-anchor='middle'>Fără imagine de cover</text></svg>`
  );
